import Profile from "./profile";

export { Profile };
export default Profile;
